module.exports = __webpack_public_path__ + "static/media/3_Card_color_horizontal.58ee31e0.svg";